// extracted by mini-css-extract-plugin
module.exports = {"StudentsLayoutWrapper":"StudentsLayout_StudentsLayoutWrapper__1XURN","ltr":"StudentsLayout_ltr__2wABg","StudentsLayoutContainer":"StudentsLayout_StudentsLayoutContainer__RhgvV"};